module.exports = __webpack_public_path__ + "img/bni.0af7ad6f.svg";